import React, { useEffect, useState } from 'react';
import screens from '../datos/journey1.json';
import { tileIcon, IconShield, IconIncome, IconCar } from './icons';

const cuidarScreen = screens.find((s) => s.key === 'cuidar');
const LABEL = {};
cuidarScreen.tiles.forEach((t) => { LABEL[t.v] = t.t; });
const VERDE = '#2F7D4F';
const NARANJA = '#E07B00';

const polar = (cx, cy, r, deg) => {
  const a = ((deg - 90) * Math.PI) / 180;
  return [cx + r * Math.cos(a), cy + r * Math.sin(a)];
};

// Qué tiene (verde) y qué le falta (naranja) según el momento y lo que marcó en «¿Qué quieres cuidar?»
const segmentos = (lead) => {
  const cuidar = lead.cuidar && lead.cuidar.length ? lead.cuidar : [];
  const lc = (t) => t.charAt(0).toLowerCase() + t.slice(1);
  if (String(lead.momento || '').startsWith('D1')) {
    return [
      { v: 'soat', label: 'SOAT', Icon: IconShield, ok: true },
      { v: 'vida-credito', label: 'Seguro de vida del crédito', Icon: IconIncome, ok: true },
      { v: 'Auto', label: 'seguro todo riesgo para tu carro', Icon: IconCar, ok: false },
      ...cuidar.filter((v) => v !== 'Auto').map((v) => ({ v, label: lc(LABEL[v] || v), Icon: tileIcon('cuidar', v), ok: false })),
    ];
  }
  return cuidar.map((v) => ({ v, label: lc(LABEL[v] || v), Icon: tileIcon('cuidar', v), ok: false }));
};

export const StoryRing = ({ lead, size = 340 }) => {
  const [armed, setArmed] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setArmed(true), 40);
    return () => clearTimeout(t);
  }, []);

  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2 - 46;
  const coreR = size * 0.21;
  const items = segmentos(lead);
  const n = items.length || 1;
  const seg = 360 / n;
  const tiene = items.filter((it) => it.ok).length;
  const nombre = (lead.nombre || '').trim().split(' ')[0];

  const arc = (i) => {
    const a0 = i * seg + (n > 1 ? 4 : 1);
    const a1 = (i + 1) * seg - (n > 1 ? 4 : 1);
    const [x0, y0] = polar(cx, cy, r, a0);
    const [x1, y1] = polar(cx, cy, r, a1);
    const large = a1 - a0 > 180 ? 1 : 0;
    return `M ${x0.toFixed(1)} ${y0.toFixed(1)} A ${r} ${r} 0 ${large} 1 ${x1.toFixed(1)} ${y1.toFixed(1)}`;
  };

  const gapIdx = items.findIndex((it) => !it.ok);
  const mainGap = gapIdx === -1 ? null : items[gapIdx];
  const gapMid = gapIdx === -1 ? -1 : gapIdx * seg + seg / 2;
  const [labX, labY] = gapMid === -1 ? [cx, cy] : polar(cx, cy, r + 34, gapMid);

  return (
    <div className="story-ring" style={{ width: size, height: size }} data-testid="story-ring">
      <svg width={size} height={size} aria-label="Mapa de protección">
        <circle cx={cx} cy={cy} r={r} fill="none" stroke="#EDEDED" strokeWidth={12} />
        {items.map((it, i) => {
          const [ix, iy] = polar(cx, cy, r, i * seg + seg / 2);
          const color = it.ok ? VERDE : NARANJA;
          return (
            <g
              key={it.v}
              className={`sr-seg ${armed ? 'in' : ''} ${it.ok ? 'full' : 'gap'}`}
              style={{ transitionDelay: `${i * 90}ms` }}
              data-testid={`sr-seg-${i}`}
              data-covered={it.ok}
              data-color={it.ok ? 'verde' : 'naranja'}
            >
              <title>{it.ok ? `Ya lo tienes: ${it.label}` : `Te falta: ${it.label}`}</title>
              <path d={arc(i)} fill="none" stroke={color} strokeWidth={12} strokeLinecap="round" />
              <circle cx={ix} cy={iy} r={19} fill="#FFFFFF" stroke={color} strokeWidth={2.5} />
              <g transform={`translate(${ix - 11}, ${iy - 11})`} color={color}>
                <it.Icon size={22} />
              </g>
            </g>
          );
        })}
      </svg>

      <div className="sr-center" style={{ width: coreR * 2, height: coreR * 2 }} data-testid="sr-center">
        <span className="sr-center-v">
          {nombre ? `${nombre}, tienes` : 'Tienes'} {tiene} de {items.length} cubiertos
        </span>
      </div>

      {mainGap ? (
        <div className={`sr-gap-label ${armed ? 'in' : ''}`} style={{ left: labX, top: labY }} data-testid="sr-gap-label">
          <strong>Te falta: {mainGap.label}</strong>
        </div>
      ) : null}
    </div>
  );
};
